import { LoginPage } from '@contexts/Auth/components/LoginPage'

export const Login = () => {
  return <LoginPage />
}
